module.exports = __webpack_public_path__ + "img/reception.e043637c.svg";